import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'ProductCount',
  props: {
    count: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  computed: {
    result: function result() {
      return "".concat(this.count, " ").concat(this.$i18n.tc('product', this.count));
    }
  }
};